module.exports = __webpack_public_path__ + "static/media/tj.a8ed5244.svg";